import React from "react";
import Modal from "react-bootstrap/Modal";
import { isRTL } from "../../../utils";

export default function Popup({ size, show, children, style, zIndex }) {
  return (
    <>
      <Modal
        size={size ? size : "lg"}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`popup ${style}`}
        show={show}
        backdrop="true"
        dir={!isRTL ? "ltr" : "rtl"}
        style={{ zIndex: zIndex || 1050 }}
      >
        {children}
      </Modal>
    </>
  );
}
